/**
 * Comments —— 评论区主组件
 *
 * 职责：
 * 1. 根据 URL 参数 comment_id 滚动定位并高亮目标评论
 * 2. 提供评论高亮方法供外部（@ 提及链接）调用
 */

import { EmojiPicker } from "./EmojiPicker";
import { Folder } from "./Folder";
import { Menu } from "./Menu";
import { Publisher } from "./Publisher";
import { Replier } from "./Replier";
import { Threader } from "./Threader";
import { Vote } from "./Vote";
export class Comments {
  constructor() {
    this.scrollToTargetComment();
    up.emit("comments:ready");
    up.on("auth:signin", Comments.showMenu);
  }

  /**
   * 登录后显示当前用户所有评论的三点菜单
   * 职责：无刷新登录后，遍历当前用户的评论，移除三点菜单的 hidden 类使其可见。
   * 菜单 DOM 由服务端始终渲染（未登录时带 hidden），JS 只负责显示/隐藏。
   */
  static showMenu = (event: any): void => {
    const items = document.querySelectorAll<HTMLElement>(
      "#comments [data-author]",
    );
    for (const item of items) {
      const menu = item.querySelector<HTMLElement>(".comment-menu");
      if (item.dataset.author === event.username && menu) {
        menu.classList.remove("hidden");
      }
    }
  };

  /**
   * 高亮指定评论（短暂闪烁效果，2.5 秒后自动移除）
   */
  highlightComment(commentId: number): void {
    const target = document.getElementById(`comment-${commentId}`);
    if (!target) return;

    target.scrollIntoView({ behavior: "smooth", block: "center" });
    target.classList.add("comment-highlight");
    setTimeout(() => target.classList.remove("comment-highlight"), 2500);
  }

  /**
   * 检查 URL 参数 comment_id，滚动到对应评论并高亮
   */
  private scrollToTargetComment(): void {
    const params = new URLSearchParams(window.location.search);
    const commentId = params.get("comment_id");
    if (!commentId) return;

    // 等待 DOM 渲染完成后再滚动
    requestAnimationFrame(() =>
      setTimeout(() => {
        this.highlightComment(Number(commentId));
      }, 100),
    );
  }

  destroy(): void {
    up.off("auth:signin", Comments.showMenu);
  }

  /**
   * 注册 Unpoly 编译器
   */
  static compiler(selector: string): void {
    up.compiler(selector, () => {
      const comments = new Comments();
      return () => comments.destroy();
    });
    // 发布评论
    Publisher.compiler(`${selector} .form`, {
      target: `${selector} .items`,
      emptyHintContainer: `${selector} .empty`,
      selector: `${selector} .item`,
      emojiPickerSelector: ".emoji-picker",
    });
    // 回复表单
    Replier.compiler(`${selector} .reply-form`, ".emoji-picker");
    // 评论表情选择(用于再编辑评论时拾取 emoji)
    EmojiPicker.compiler(
      `${selector} [id^="comment-update-"] .emoji-picker`,
      `${selector} [id^="comment-update-"] textarea`,
    );
    // 评论点赞
    Vote.compiler(`${selector} .comment-vote`);
    // 评论三点菜单
    Menu.compiler(`${selector} .comment-menu`);
    // 评论折叠
    Folder.compiler(`${selector} [data-replies-toggle]`);
    // 评论线程
    Threader.compiler();
  }
}
